import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';
import { ManageProductsState } from './types';

const initState = () => {
    return new  ManageProductsState();
};

export const useManageProductsStore = createStoreModule<ManageProductsState, IAction<ManageProductsState>>(initState, 'root-ManageProducts');
